import { jsx as a, jsxs as c } from "react/jsx-runtime";
import m from "react";
import { L as j } from "./Label-B8EaZ6Vz.js";
import { T as x } from "./Typography-DjQwU5Xn.js";
import { c as f } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const d = ({
  message: s,
  type: e = "info",
  className: i,
  ...r
}) => s ? /* @__PURE__ */ a(
  x,
  {
    variant: "caption",
    className: f(
      "block leading-relaxed",
      e === "error" && "text-destructive",
      e === "success" && "text-success",
      e === "info" && "text-muted-foreground",
      i
    ),
    ...r,
    children: s
  }
) : null, D = ({
  label: s,
  error: e,
  successMessage: i,
  id: r,
  helpText: n,
  description: p,
  orientation: g = "vertical",
  required: v,
  className: y,
  children: b
}) => {
  const u = g === "horizontal", N = [
    e ? `${r}-error` : void 0,
    !e && n ? `${r}-description` : void 0
  ].filter(Boolean), w = (t) => {
    if (!m.isValidElement(t)) return t;
    const o = t.type, F = typeof t.type == "string" && ["input", "select", "textarea"].includes(t.type), B = (o == null ? void 0 : o.displayName) === "Input" || (o == null ? void 0 : o.displayName) === "SelectTrigger";
    if (!F && !B) return t;
    const l = t.props, C = l.id ?? r, $ = [l["aria-describedby"], ...N].filter(Boolean).join(" ") || void 0;
    return m.cloneElement(t, {
      id: C,
      "aria-describedby": $,
      "aria-invalid": l["aria-invalid"] ?? (e ? !0 : void 0)
    });
  };
  return /* @__PURE__ */ c("div", { className: f(
    "flex w-full",
    u ? "flex-col gap-2 sm:flex-row sm:items-start sm:gap-5" : "flex-col gap-2",
    y
  ), children: [
    /* @__PURE__ */ c("div", { className: f(
      "flex flex-col gap-1",
      u ? "sm:w-40 sm:shrink-0" : "w-full"
    ), children: [
      /* @__PURE__ */ a(
        j,
        {
          htmlFor: r,
          required: v,
          children: s
        }
      ),
      p && /* @__PURE__ */ a(x, { variant: "caption", className: "text-muted-foreground leading-relaxed", children: p })
    ] }),
    /* @__PURE__ */ c("div", { className: "flex-1 w-full space-y-1.5", children: [
      m.Children.map(b, w),
      /* @__PURE__ */ a(
        d,
        {
          id: `${r}-error`,
          message: e,
          type: "error",
          role: "alert"
        }
      ),
      !e && i && /* @__PURE__ */ a(
        d,
        {
          message: i,
          type: "success"
        }
      ),
      !e && !i && n && /* @__PURE__ */ a(
        d,
        {
          id: `${r}-description`,
          message: n,
          type: "info"
        }
      )
    ] })
  ] });
};
export {
  d as F,
  D as a
};
